import React from 'react';
import { RANK_TIERS, getRankTier } from './constants';
import RankShield from './RankShield';

const RankBadge = ({ elo, rank, size = 'medium' }) => {
  const tier = rank ? RANK_TIERS.find(t => t.name === rank) || getRankTier(elo || 1000) : getRankTier(elo || 1000);
  const sizeClass = `rank-badge-${size}`;
  const shieldSize = size === 'large' ? 48 : size === 'medium' ? 32 : 24;

  return (
    <span
      className={`rank-badge ${sizeClass}`}
      style={{ color: tier.color, background: tier.bgColor, borderColor: tier.color }}
      title={`${tier.name} — ${elo} ELO`}
    >
      <RankShield tier={tier} size={shieldSize} />
      <span className="rank-badge-name">{tier.name}</span>
    </span>
  );
};

export default RankBadge;
